"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductVariantUnit = exports.EProductVariantType = exports.EProductStatus = exports.EProductAwards = void 0;
/**
 * @deprecated WEB-2541
 */
var EProductAwards;
(function (EProductAwards) {
    EProductAwards[EProductAwards["CODE_CHECK"] = 1] = "CODE_CHECK";
    EProductAwards[EProductAwards["COSMETIC_ANALYSIS"] = 2] = "COSMETIC_ANALYSIS";
    EProductAwards[EProductAwards["ECOCERT_BIOKOSMETIK"] = 3] = "ECOCERT_BIOKOSMETIK";
    EProductAwards[EProductAwards["ECOCERT_NATURALKOSMETIK"] = 4] = "ECOCERT_NATURALKOSMETIK";
    EProductAwards[EProductAwards["COSMOS_NATURAL"] = 5] = "COSMOS_NATURAL";
    EProductAwards[EProductAwards["COSMOS_ORGANIC"] = 6] = "COSMOS_ORGANIC";
    EProductAwards[EProductAwards["KOELNER_LISTE"] = 7] = "KOELNER_LISTE";
    EProductAwards[EProductAwards["LACON"] = 8] = "LACON";
    EProductAwards[EProductAwards["PATENTIERT"] = 9] = "PATENTIERT";
    EProductAwards[EProductAwards["UMWELTZEICHEN"] = 10] = "UMWELTZEICHEN";
    EProductAwards[EProductAwards["UVA_PROTECTION"] = 11] = "UVA_PROTECTION";
})(EProductAwards = exports.EProductAwards || (exports.EProductAwards = {}));
var EProductStatus;
(function (EProductStatus) {
    EProductStatus[EProductStatus["DRAFT"] = 0] = "DRAFT";
    EProductStatus[EProductStatus["HIDDEN"] = 1] = "HIDDEN";
    EProductStatus[EProductStatus["PUBLISHED"] = 2] = "PUBLISHED";
    EProductStatus[EProductStatus["UNKNOWN"] = 3] = "UNKNOWN";
})(EProductStatus = exports.EProductStatus || (exports.EProductStatus = {}));
var EProductVariantType;
(function (EProductVariantType) {
    EProductVariantType[EProductVariantType["COLOR"] = 1] = "COLOR";
    EProductVariantType[EProductVariantType["SIZE"] = 2] = "SIZE";
    EProductVariantType[EProductVariantType["LANGUAGE"] = 3] = "LANGUAGE";
})(EProductVariantType = exports.EProductVariantType || (exports.EProductVariantType = {}));
var EProductVariantUnit;
(function (EProductVariantUnit) {
    EProductVariantUnit[EProductVariantUnit["CAPS"] = 1] = "CAPS";
    EProductVariantUnit[EProductVariantUnit["GRAM"] = 2] = "GRAM";
    EProductVariantUnit[EProductVariantUnit["TRIAL"] = 3] = "TRIAL";
    EProductVariantUnit[EProductVariantUnit["SET"] = 4] = "SET";
    EProductVariantUnit[EProductVariantUnit["AMOUNT"] = 5] = "AMOUNT";
})(EProductVariantUnit = exports.EProductVariantUnit || (exports.EProductVariantUnit = {}));
